import React, { Fragment } from 'react';
import MissingDatesView from './MissingDatesView';

// Thin route entry — the V3 shell lives inside the view.
const MissingDatesReport = () => (
    <Fragment>
        <MissingDatesView />
    </Fragment>
);

export default MissingDatesReport;
